import { memo as Memo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const SharpyJump = Memo(({ animate }) => {
	const rootRef = useRef(null);
	const flRef = useRef(null);
	const frRef = useRef(null);
	const hlRef = useRef(null);
	const hrRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		const ctx = gsap.context(() => {
			const tl = gsap.timeline({ paused: true });

			tl.to(rootRef.current, { duration: 0.2, y: -20 })
				.to(flRef.current, { duration: 0.2, svgOrigin: '72 177', rotation: 30 }, 0)
				.to(frRef.current, { duration: 0.2, svgOrigin: '114 177', rotation: -30 }, 0)
				.to(hlRef.current, { duration: 0.2, svgOrigin: '27 140', rotation: 30 }, 0)
				.to(hrRef.current, { duration: 0.2, svgOrigin: '159 140', rotation: -30 }, 0)
				.to(rootRef.current, { duration: 0.2, y: 0 }, 0.2)
				.to(flRef.current, { duration: 0.2, svgOrigin: '72 177', rotation: 0 }, 0.2)
				.to(frRef.current, { duration: 0.2, svgOrigin: '114 177', rotation: 0 }, 0.2)
				.to(hlRef.current, { duration: 0.2, svgOrigin: '27 140', rotation: 0 }, 0.2)
				.to(hrRef.current, { duration: 0.2, svgOrigin: '159 140', rotation: 0 }, 0.2);

			animRef.current = tl;
		}, rootRef);

		return () => ctx.revert();
	}, []);

	useEffect(() => {
		if (animate && animRef.current) {
			animRef.current.progress(0).play();
		}
	}, [animate]);

	return (
		<svg
			ref={rootRef}
			className={`svg-max sharpyJump`}
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 187.58 224.68'>
			<path
				ref={hlRef}
				className={`sharpyJump-hl defaultStyle`}
				d='M27.83,140.47A46,46,0,0,0,1.75,162.28'
			/>
			<path
				ref={hrRef}
				className={`sharpyJump-hr defaultStyle`}
				d='M159.75,140.47a46,46,0,0,1,26.08,21.81'
			/>
			<path
				className={'fill'}
				d='M163.49,184H18.06C18.06,82.38,83.17,0,163.49,0h0Z'
			/>
			<path
				ref={flRef}
				className={`sharpyJump-fl defaultStyle`}
				d='M72.23,177.39c-.53,6-1.72,22.21-2.57,32.49a13,13,0,0,1-9.26,11.37l-5.63,1.68'
			/>
			<path
				ref={frRef}
				className={`sharpyJump-fr defaultStyle`}
				d='M114.77,177.39c.54,6,1.72,22.21,2.58,32.49a13,13,0,0,0,9.26,11.37l5.62,1.68'
			/>
		</svg>
	);
});

export default SharpyJump;
